import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { PunchBeamPosition } from "../models/PunchBeamPosition";

export const getPunchBeamPositions = async (
	productId: number,
): Promise<PunchBeamPosition[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductId", value: productId }];
	const resp = await apiService.callV2(
		"[FAB].[GetPunchBeamPositions]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as PunchBeamPosition[];
	}
	throw new Error(resp.message || "Error fetching punch beam positions");
};

export const setPunchBeamPositions = async (
	productId: number,
	positions: Array<
		Pick<
			PunchBeamPosition,
			"PunchBeamPositionId" | "Plate" | "PositionOrder" | "PositionValue"
		>
	>,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProductId", value: productId },
		{ name: "Positions", value: JSON.stringify(positions) },
	];
	return await apiService.callV2("[FAB].[SetPunchBeamPositions]", parameters);
};
